import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getBigcommerceIntegration = unaryRpc({
  name: "getBigcommerceIntegration" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ hasBigcommerceIntegration: z.boolean() }),
});
